import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment/moment';

import { Button, SubmitButton } from '../../../../../../common/button';
import { SelectFieldFormik } from '../../../../../../common/select_field';
import { DateTimePickerFormik } from '../../../../../../common/date_picker';
import { parseDateString } from '../../../../../../../core/utils/date_utils';
import { TwoLevelSteps } from '../../../../../common/steps';
import { getAllPodsState } from '../../../../../../../features/pod/get_all_pods';
import { GET_ROUTE_CUSTOMER } from '../../../../../../../core/constants';
import SectionPaper from '../../../../../../common/section_paper';
import BottomActionBar from '../../../../../../common/bottom_action_bar';

const GeneralDataForm = ({ customerId, form, onSubmitGeneralData }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const getAllPods = useSelector(getAllPodsState);

    const initialValues = {
        podId: form?.podId || '',
        orderDate: form?.orderDate || ''
    };

    const schema = Yup.object().shape({
        podId: Yup.string().required(),
        orderDate: Yup.date()
            .transform(parseDateString)
            .nullable()
            .required()
    });

    return (
        <Formik
            initialValues={ initialValues }
            validationSchema={ schema }
            validateOnChange={ false }
            validateOnBlur={ false }
            onSubmit={ onSubmitGeneralData }>
            { () => (
                <Box component={ Form } sx={ { display: 'flex', flexDirection: 'column', gap: 3, flexGrow: 1, pt: 2 } }>
                    <TwoLevelSteps firstStep/>

                    <Box sx={ { flexGrow: 1, pb: 4 } }>
                        <SectionPaper title="Dane zamówienia">
                            <Box sx={ {
                                display: 'grid',
                                gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
                                gap: 3
                            } }>
                                <DateTimePickerFormik
                                    name="orderDate"
                                    label="Data zakupów"
                                    required
                                    maxDate={ moment() }
                                    InputLabelProps={ { shrink: true } }
                                />
                                <SelectFieldFormik
                                    name="podId"
                                    label="Punkt sprzedaży"
                                    options={ getAllPods?.data?.map(pod => ({
                                        value: pod?.id,
                                        label: pod?.indoorPartner?.name + ' (' + pod?.description + ') - ' + (pod?.device?.serviceId || 'brak urządzenia')
                                    })) }
                                    required
                                />
                            </Box>
                        </SectionPaper>
                    </Box>

                    <BottomActionBar>
                        <Box sx={ { display: 'flex', justifyContent: 'space-between', width: '100%' } }>
                            <Button
                                variant="outlined"
                                onClick={ () => navigate(GET_ROUTE_CUSTOMER(customerId), { state: { tab: location?.state?.tab } }) }
                            >
                                Anuluj
                            </Button>
                            <SubmitButton>Dalej</SubmitButton>
                        </Box>
                    </BottomActionBar>
                </Box>
            ) }
        </Formik>
    );
};

export default GeneralDataForm;